import styled from 'styled-components'
import { SPACING, BORDER_RADIUS } from '../../../styles/theme'
import { SkeletonBox } from '../styles/SkeletonStyles'
import { AppLayout, AppContent } from '../../../styles/AppStyles'
import { SkeletonAppHeader } from './SkeletonAppHeader'

const Page = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${SPACING.xxl} ${SPACING.xl};
`

const Content = styled.div`
  width: 100%;
  max-width: 620px;
  display: flex;
  flex-direction: column;
`

const HeaderBlock = styled.div`
  margin-bottom: ${SPACING.xxl};
  display: flex;
  flex-direction: column;
  gap: ${SPACING.sm};
`

const QuestionCard = styled.div`
  background: var(--color-bg-card);
  border: 1px solid var(--color-border-card);
  border-radius: ${BORDER_RADIUS.xl};
  padding: ${SPACING.xl};
  margin-bottom: ${SPACING.md};
  display: flex;
  flex-direction: column;
  gap: ${SPACING.lg};
`

const QuestionMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export function SkeletonSurveyParticipant() {
  return (
    <AppLayout>
      <SkeletonAppHeader />
      <AppContent>
        <Page>
          <Content>
            {/* Survey header */}
            <HeaderBlock>
              <SkeletonBox $width="120px" $height="14px" $radius={BORDER_RADIUS.sm} />
              <SkeletonBox $width="75%" $height="28px" $radius={BORDER_RADIUS.lg} />
              <SkeletonBox $width="80px" $height="14px" $radius={BORDER_RADIUS.sm} />
            </HeaderBlock>

            {/* Question cards */}
            {[null, null, null].map((_, i) => (
              <QuestionCard key={i}>
                <QuestionMeta>
                  <SkeletonBox $width="100px" $height="12px" $radius={BORDER_RADIUS.sm} />
                </QuestionMeta>
                <SkeletonBox $width="85%" $height="16px" $radius={BORDER_RADIUS.sm} />
                <SkeletonBox $width="100%" $height="80px" $radius={BORDER_RADIUS.xl} />
              </QuestionCard>
            ))}

            {/* Submit button */}
            <SkeletonBox
              $width="100%"
              $height="48px"
              $radius={BORDER_RADIUS.lg}
              style={{ marginTop: SPACING.xl }}
            />
          </Content>
        </Page>
      </AppContent>
    </AppLayout>
  )
}
